import React, { useEffect, useState } from "react";
import { Button, Modal, Table, Row, Col } from "react-bootstrap";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import { Toaster, toast } from "sonner";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { TiDeleteOutline } from "react-icons/ti";
import axios from "axios";
import { MdDelete, MdDeleteOutline } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
const HouseCategory = () => {
  const [show, setShow] = useState(false);
  const [editid, seteditid] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [category, setcategory] = useState([]);

  const getItemCategory = async () => {
    try {
      let res = await axios.get("https://vrpmpro.com/api/admin/category");
      if (res.status == 200) {
        setcategory(res.data.categories);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [Subcate, setSubCatList] = useState([]);

  const getSubCategory = async () => {
    try {
      let res = await axios.get(
        "https://vrpmpro.com/api/admin/getAllsubcategory"
      );
      if (res.status == 200) {
        setSubCatList(res.data.success);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getItemCategory();
    getSubCategory();
  }, []);

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );

  // console.log("category",category);

  const { SearchBar, ClearSearchButton } = Search;
  const { ExportCSVButton } = CSVExport;
  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: category.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  const options1 = {
    paginationSize: 4,
    pageStartIndex: 0,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: Subcate.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  const [showD, setshowD] = useState(false);
  const [subcat, setshowcate] = useState(false);
  const [typeName, setTypeName] = useState("");
  const [deleteId, setdeleteId] = useState("");
  const [typeImage, setTypeImage] = useState(null);
  const [price, setPrice] = useState("");
  const [gst, setGst] = useState("");
  const [editShow, seteditshow] = useState(false);
  const makeDelete = async () => {
    try {
      let res = await axios.delete(
        `https://vrpmpro.com/api/admin/category/${deleteId}`
      );
      if (res.status == 200) {
        setshowD(false);
        getItemCategory();
        alert("Deleted Successfully");
      }
    } catch (error) {
      console.log(error);
      alert("Not able to delete");
    }
  };

  const columns = [
    {
      text: "S.No",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <div>{rowIndex + 1}</div>;
      },
    },
    {
      dataField: "name",
      text: "Category Name",
    },

    {
      dataField: "gst",
      text: "Action",
      formatter: (cee, row) => {
        return (
          <div className="d-flex gap-2">
            <abbr
              title="Edit"
              className="btn btn-outline-primary"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setTypeName(row?.name);
                seteditid(row?._id);
                seteditshow(true);
              }}
            >
              <FaEdit size={25} />
            </abbr>
            <abbr
              title="Delete"
              onClick={() => {
                setdeleteId(row._id);
                setshowD(true);
              }}
              className="btn btn-outline-danger"
              style={{ cursor: "pointer" }}
            >
              <MdDeleteOutline size={25} />
            </abbr>
          </div>
        );
      },
    },
  ];

  const [subId,setsubId]=useState("");
  const [itemId,setItemId]=useState("");

  const deleteItemData=async()=>{
    try {
      
    } catch (error) {
      console.log(error);
      
    }
  }
  const columns1 = [
    {
      text: "S.No",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <div>{rowIndex + 1}</div>;
      },
    },
    {
      dataField: "category",
      text: "Category",
    },
    {
      dataField: "subcategory",
      text: "Subcategory",
    },
    {
      // dataField: "subcategoryitems",
      text: "Item List - Base Price - Per km Price",
      formatter: (cell, row) => {
        return (
          <ul class="list-group mt-2 ms-2">
            {row?.subcategoryitems?.map((ele) => {
              return (
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  {ele?.itemName} - ₹{ele?.baseprice} - ₹{ele?.perkmprice}
                  <span
                    class="badge bg-danger rounded-pill"
                    style={{ cursor: "pointer" }}
                    onClick={() => deleteItem(ele?.itemName)}
                  >
                    <MdDelete />
                  </span>
                </li>
              );
            })}
          </ul>
        );
      },
    },
    {
      dataField: "gst",
      text: "Action",
      formatter: (cee, row) => {
        return (
          <div className="d-flex gap-2">
            <abbr
              title="Edit"
              className="btn btn-outline-primary"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setTypeName(row?.name);
                seteditid(row?._id);
                seteditshow(true);
              }}
            >
              <FaEdit size={25} />
            </abbr>
            <abbr
              title="Delete"
              onClick={() => {
                setdeleteId(row._id);
                setshowD(true);
              }}
              className="btn btn-outline-danger"
              style={{ cursor: "pointer" }}
            >
              <MdDeleteOutline size={25} />
            </abbr>
          </div>
        );
      },
    },
  ];
  const defaultSorted = [
    {
      dataField: "propertytype",
      order: "desc",
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    let check = category.filter((ele) => ele?.name == typeName);
    if (check.length != 0) return alert("Category already exits");

    try {
      const config = {
        url: "/admin/addcategory",
        method: "post",
        baseURL: "https://vrpmpro.com/api",
        headers: { "content-type": "application/json" },
        data: {
          name: typeName,
        },
      };
      // Make API call to backend
      const response = await axios(config);
      // Handle response from the API
      console.log(response.data);
      toast.success("Category added successfully!");
      handleClose();
      setTypeName("");
      getItemCategory();
    } catch (error) {
      // Handle errors
      console.log(error);
      toast.error("Error submitting form. Please try again.");
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();

    let check = category.filter(
      (ele) => ele?.name == typeName && ele?._id != editid
    );
    if (check.length != 0) return toast.error("Category already exits");
    try {
      const config = {
        url: "/admin/updatecategory",
        method: "put",
        baseURL: "https://vrpmpro.com/api",
        headers: { "content-type": "application/json" },
        data: {
          name: typeName,
          id: editid,
        },
      };
      // Make API call to backend
      const response = await axios(config);
      // Handle response from the API
      if (response.status == 200) {
        console.log(response.data);
        toast.success("Category updated successfully!");
        seteditshow(false);
        setTypeName("");

        getItemCategory();
      }
    } catch (error) {
      // Handle errors
      console.log("Error submitting form", error);
      toast.error("Error submitting form. Please try again.");
    }
  };

  //sub categoty

  const [subcatname, setsubcatname] = useState("");
  const [cat, setcat] = useState("");
  const [listItems, setListItem] = useState([]);

  const [subcatid, setsubcatid] = useState("");
  const [subcatlist, setsubcatlist] = useState([]);
  const [subcatshow, setsubcatshow] = useState(false);
  const [subcatnameedit, setsubcatnameedit] = useState("");
  const [subcatidedit, setsubcatidedit] = useState("");
  const [subcatlistedit, setsubcatlistedit] = useState([]);
  const [subcatshowedit, setsubcatshowedit] = useState(false);

  const handleSubcat = async (e) => {
    e.preventDefault();
    let check = Subcate.filter(
      (ele) => ele?.category == cat && ele?.subcategory == subcatname
    );
    if (check.length != 0) return toast.error("Sub Category already exits");
    try {
      const config = {
        url: "/admin/addsubcategory",
        method: "post",
        baseURL: "https://vrpmpro.com/api",
        headers: { "content-type": "application/json" },
        data: {
          subcategory: subcatname,
          category: cat,
          subcategoryitems: listItems,
        },
      };
      // Make API call to backend
      const response = await axios(config);
      // Handle response from the API
      if (response.status == 201) {
        toast.success("Sub Category added successfully!");
        setsubcatshow(false);
        setsubcatname("");
        setshowcate(true);
        setcat("");
        setListItem([]);
        getSubCategory();
      }
    } catch (error) {
      // Handle errors
      console.log("Error submitting form", error);
      toast.error("Error submitting form. Please try again.");
    }
  };

  const [itemName, setItemName] = useState("");
  const [baseprice, setbaseprice] = useState("");
  const [perkmprice, setperkmprice] = useState("");

  const addItems = () => {
    try {
      if (!itemName) return toast.warning("Please enter your item name");
      if (listItems?.some((ele) => ele?.itemName == itemName))
        return toast.warning("Item already exists");
      setListItem([
        ...listItems,
        { itemName: itemName, baseprice: baseprice, perkmprice: perkmprice },
      ]);
      setItemName("");
      setbaseprice("");
      setperkmprice("");
      return toast.success("Item added successfully");
    } catch (error) {
      console.log(error);
    }
  };

  const deleteItem = (itemName) => {
    try {
      const item = listItems.find((ele) => ele.itemName === itemName);
      if (!item) return toast.warning("Item not found");
      setListItem(listItems.filter((ele) => ele.itemName !== itemName));
      return toast.success("Item deleted successfully");
    } catch (error) {
      console.log(error);
    }
  };

  console.log("Subcate", Subcate);

  return (
    <div className="ml-4">
      <Toaster position="top-center" />

      <h1 className="pt-4 pb-3" style={{ color: "white" }}>
        House Items Category
      </h1>
      <div className="container">
        <div className="card card-body">
          <ToolkitProvider
            keyField="id"
            data={subcat ? Subcate : category}
            columns={subcat ? columns1 : columns}
            defaultSorted={defaultSorted}
            search
            exportCSV={{
              fileName: "properties.csv",
              blobType: "text/csv;charset=ansi",
            }}
          >
            {(props) => (
              <div>
                <span className="pr-5 mr-auto">
                  <ExportCSVButton
                    className="btn-outline-success"
                    {...props.csvProps}
                  >
                    Export to CSV
                  </ExportCSVButton>
                </span>
                {"     "}
                <span className="ps-5 ml-5 mt-3">
                  <SearchBar className="form-control " {...props.searchProps} />
                </span>
                {"      "}
                <ClearSearchButton
                  className="btn-outline-info ms-5 "
                  {...props.searchProps}
                />
                <span className="ps-5 ml-5 mt-3">
                  <button
                    className="btn btn-outline-danger"
                    onClick={() =>
                      subcat ? setsubcatshow(true) : handleShow()
                    }
                  >
                    {subcat ? "Add Item Sub-Category" : "Add Item Category"}
                  </button>
                </span>
                <span className="ps-5 ml-5 mt-3">
                  <button
                    className="btn btn-outline-success"
                    onClick={() => setshowcate(!subcat)}
                  >
                    {subcat ? "Category List" : "Sub-Category List"}
                  </button>
                </span>
                <hr />
                <div className="table-responsive">
                  {subcat ? (
                    <BootstrapTable
                      keyField="patient"
                      responsive
                      hover
                      columns={columns1}
                      data={Subcate}
                      pagination={paginationFactory(options1)}
                      {...props.baseProps}
                    />
                  ) : (
                    <BootstrapTable
                      keyField="patient"
                      responsive
                      hover
                      columns={columns}
                      data={category}
                      pagination={paginationFactory(options)}
                      {...props.baseProps}
                    />
                  )}
                </div>
              </div>
            )}
          </ToolkitProvider>
        </div>
      </div>
      {/* Modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Item Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="container mt-2">
            <form onSubmit={handleSubmit}>
              <div class="mb-3">
                <label for="itemcat" class="form-label">
                  Item Category
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="itemcat"
                  value={typeName}
                  placeholder="Enter item category (e.g. Furniture)"
                  required
                  onChange={(e) => setTypeName(e.target.value)}
                />
              </div>
              <button type="submit" class="btn btn-outline-success">
                Submit
              </button>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-outline-danger" onClick={handleClose}>
            Close
          </button>
          {/* <button className="btn btn-outline-success" onClick={handleClose}>
                        Save Changes
                    </button> */}
        </Modal.Footer>
      </Modal>

      <Modal show={subcatshow} onHide={() => setsubcatshow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Sub-Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="container mt-2">
            <form onSubmit={handleSubcat}>
              <div class="mb-3">
                <label for="selectcat" class="form-label">
                  Item Category
                </label>
                <select
                  class="form-control"
                  id="selectcat"
                  value={cat}
                  onChange={(e) => setcat(e.target.value)}
                >
                  <option value="">Select Category</option>
                  {category?.map((ele) => {
                    return (
                      <option key={ele?._id} value={ele?.name}>
                        {ele?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div class="mb-3">
                <label for="subcate" class="form-label">
                  Sub-Category
                </label>

                <input
                  type="text"
                  id="subcate"
                  class="form-control"
                  value={subcatname}
                  onChange={(e) => setsubcatname(e.target.value)}
                  placeholder="Enter sub-category (e.g. Sofa)"
                  required
                />
              </div>
              <div class="mb-3">
                <label htmlFor="subcatitem" class="form-label">
                  Sub-Category items list
                </label>
                <div className="row">
                  <div className="col-md-6">
                    <input
                      type="text"
                      id="subcatitem"
                      value={itemName}
                      onChange={(e) => setItemName(e.target.value)}
                      class="form-control"
                      placeholder="item name e.g. round sofa"
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      value={baseprice}
                      onChange={(e) => setbaseprice(e.target.value)}
                      class="form-control"
                      placeholder="item base price"
                    />
                  </div>
                  <div className="col-md-6 mt-2">
                    <input
                      type="text"
                      value={perkmprice}
                      onChange={(e) => setperkmprice(e.target.value)}
                      class="form-control"
                      placeholder="item per km price"
                    />
                  </div>
                  <div className="col-md-6 mt-2">
                    <button
                      type="button"
                      class="btn btn-success"
                      onClick={addItems}
                    >
                      Add
                    </button>
                  </div>
                  <ul class="list-group mt-2 ms-2">
                    {listItems?.map((ele) => {
                      return (
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          {ele?.itemName} - ₹{ele?.baseprice} - ₹
                          {ele?.perkmprice}
                          <span
                            class="badge bg-danger rounded-pill"
                            style={{ cursor: "pointer" }}
                            onClick={() => deleteItem(ele?.itemName)}
                          >
                            <MdDelete />
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <button type="submit" class="btn btn-outline-success">
                Submit
              </button>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-outline-danger" onClick={handleClose}>
            Close
          </button>
          {/* <button className="btn btn-outline-success" onClick={handleClose}>
                        Save Changes
                    </button> */}
        </Modal.Footer>
      </Modal>
      {/* Modal */}
      <Modal show={editShow} onHide={() => seteditshow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Item Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="container mt-2">
            <form onSubmit={handleEdit}>
              <div class="mb-3">
                <label for="itemcat1" class="form-label">
                  Item Category
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="itemcat1"
                  value={typeName}
                  placeholder="Enter item category (e.g. Furniture)"
                  required
                  onChange={(e) => setTypeName(e.target.value)}
                />
              </div>

              <button type="submit" class="btn btn-outline-success">
                Save Changes
              </button>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-outline-danger"
            onClick={() => seteditshow(false)}
          >
            Close
          </button>
          {/* <button className="btn btn-outline-success" onClick={handleClose}>
                        Save Changes
                    </button> */}
        </Modal.Footer>
      </Modal>

      <Modal show={showD} onHide={() => setshowD(false)} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>Are you sure delete ?</Modal.Title>
        </Modal.Header>

        <Modal.Footer>
          <button
            className="btn btn-outline-danger"
            onClick={() => setshowD(false)}
          >
            Cancel
          </button>
          <button className="btn btn-outline-success" onClick={makeDelete}>
            Save Changes
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default HouseCategory;
